import React, { useState } from 'react';
import {
  Box,
  Typography,
  Card,
  TextField,
  InputAdornment,
  SvgIcon,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Tooltip,
  IconButton,
  Button,
  ButtonGroup,
  Popover
} from '@material-ui/core';
import { Search as SearchIcon } from 'react-feather';
import CloseIcon from '@material-ui/icons/Close';
import FilterListIcon from '@material-ui/icons/FilterList';
import GetAppIcon from '@material-ui/icons/GetApp';
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import AddCircleIcon from '@material-ui/icons/AddCircle';

const ToolbarSection = ({
  classes,
  STATUS_CONFIG,
  filterStatus,
  setFilterStatus,
  countsByStatus,
  searchInput,
  handleSearch,
  fromDate,
  setFromDate,
  toDate,
  setToDate,
  filterPaymentStatus,
  setFilterPaymentStatus,
  filterDevice,
  setFilterDevice,
  filterSale,
  setFilterSale,
  filterItemType,
  setFilterItemType,
  listDeviceType,
  listSales,
  search,
  setSearch,
  setSearchInput,
  setPage,
  isAdmin,
  isAccountant,
  isSale,
  isLeadMarketing,
  isAdminSale,
  isAgencySale,
  isVmakeSale,
  dataLogin,
  setTabForm,
  setIsEditing,
  setEditOrderId,
  setForm,
  setDevices,
  setOrderParts,
  setSelectedUser,
  setOpenAddModal,
  handleExportExcel,
  canManageReceipts,
  onOpenAddReceiptGeneral,
  transactionTypeFilter = 'ALL',
  setTransactionTypeFilter,
  isAnySale: propIsAnySale
}) => {
  const isAnySale = Boolean(propIsAnySale || isSale || isLeadMarketing || isAdminSale || isAgencySale || isVmakeSale);
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);

  const availableSales = isLeadMarketing && dataLogin?.id
    ? (listSales || []).filter(u => u.manager_id === dataLogin.id || u.id === dataLogin.id)
    : (listSales || []);

  const handleFilterClick = event => {
    setFilterAnchorEl(event.currentTarget);
  };

  const handleFilterClose = () => {
    setFilterAnchorEl(null);
  };

  const activeFilterCount = [
    !isAnySale && transactionTypeFilter && transactionTypeFilter !== 'ALL',
    filterDevice !== 'all',
    filterSale !== 'all'
  ].filter(Boolean).length;

  return (
    <>

      <Card
        className={classes.toolbar}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          padding: '10px 16px',
          marginBottom: 14,
          borderRadius: 12,
          border: '1px solid #e2e8f0',
          boxShadow: '0 1px 3px rgba(0,0,0,0.03)',
          backgroundColor: '#ffffff',
          flexWrap: 'nowrap'
        }}
      >
        <TextField
          id="search-orders"
          placeholder="Tìm theo tên khách, SĐT, mã đơn, Serial..."
          variant="outlined"
          size="small"
          value={searchInput}
          onChange={handleSearch}
          style={{ flex: '1 1 280px', maxWidth: 460 }}
          InputProps={{
            style: {
              height: 44,
              borderRadius: 8,
              backgroundColor: '#f8fafc',
              fontSize: 13
            },
            startAdornment: (
              <InputAdornment position="start">
                <SvgIcon fontSize="small" style={{ color: '#64748b' }}>
                  <SearchIcon />
                </SvgIcon>
              </InputAdornment>
            ),
            endAdornment: searchInput ? (
              <InputAdornment position="end">
                <IconButton
                  size="small"
                  onClick={() => {
                    setSearchInput('');
                    setSearch('');
                    setPage(1);
                  }}
                >
                  <CloseIcon style={{ fontSize: 16 }} />
                </IconButton>
              </InputAdornment>
            ) : null
          }}
        />

        <TextField
          label="Từ ngày"
          type="date"
          variant="outlined"
          size="small"
          value={fromDate}
          onChange={e => {
            setFromDate(e.target.value);
            setPage(1);
          }}
          style={{ width: 142 }}
          InputLabelProps={{
            shrink: true,
            style: {
              backgroundColor: 'white',
              padding: '0 4px',
              fontSize: 12,
              color: '#64748b'
            }
          }}
          InputProps={{
            style: { height: 40, borderRadius: 8, fontSize: 13 },
            endAdornment: fromDate ? (
              <InputAdornment
                position="end"
                style={{ position: 'absolute', right: 26 }}
              >
                <IconButton
                  size="small"
                  onClick={() => {
                    setFromDate('');
                    setPage(1);
                  }}
                  style={{ padding: 2 }}
                >
                  <CloseIcon style={{ fontSize: 13 }} />
                </IconButton>
              </InputAdornment>
            ) : null
          }}
        />

        <TextField
          label="Đến ngày"
          type="date"
          variant="outlined"
          size="small"
          value={toDate}
          onChange={e => {
            setToDate(e.target.value);
            setPage(1);
          }}
          style={{ width: 142 }}
          InputLabelProps={{
            shrink: true,
            style: {
              backgroundColor: 'white',
              padding: '0 4px',
              fontSize: 12,
              color: '#64748b'
            }
          }}
          InputProps={{
            style: { height: 40, borderRadius: 8, fontSize: 13 },
            endAdornment: toDate ? (
              <InputAdornment
                position="end"
                style={{ position: 'absolute', right: 26 }}
              >
                <IconButton
                  size="small"
                  onClick={() => {
                    setToDate('');
                    setPage(1);
                  }}
                  style={{ padding: 2 }}
                >
                  <CloseIcon style={{ fontSize: 13 }} />
                </IconButton>
              </InputAdornment>
            ) : null
          }}
        />

        <Button
          variant="outlined"
          size="small"
          onClick={handleFilterClick}
          startIcon={<FilterListIcon style={{ fontSize: 18 }} />}
          style={{
            height: 44,
            boxSizing: 'border-box',
            borderRadius: 8,
            textTransform: 'none',
            fontWeight: 600,
            fontSize: 13,
            whiteSpace: 'nowrap',
            padding: '0 16px',
            marginTop: -3,
            color: activeFilterCount > 0 ? '#e11d48' : '#475569',
            borderColor: activeFilterCount > 0 ? '#f43f5e' : '#cbd5e1',
            backgroundColor: activeFilterCount > 0 ? '#fff1f2' : '#ffffff'
          }}
        >
          Bộ lọc {activeFilterCount > 0 ? `(${activeFilterCount})` : ''}
        </Button>

        <Popover
          open={Boolean(filterAnchorEl)}
          anchorEl={filterAnchorEl}
          onClose={handleFilterClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left'
          }}
          PaperProps={{
            style: {
              padding: 20,
              width: 300,
              display: 'flex',
              flexDirection: 'column',
              gap: 16,
              borderRadius: 12,
              marginTop: 8,
              boxShadow: '0 8px 24px rgba(0,0,0,0.12)'
            }
          }}
        >
          <Typography variant="subtitle2" style={{ fontWeight: 700, color: '#1e293b' }}>
            Bộ lọc bổ sung
          </Typography>

          {!isAnySale && (
            <FormControl variant="outlined" size="small" fullWidth>
              <InputLabel
                id="popover-trans-type-label"
                style={{
                  backgroundColor: 'white',
                  padding: '0 4px',
                  marginLeft: -4
                }}
              >
                Loại giao dịch
              </InputLabel>
              <Select
                labelId="popover-trans-type-label"
                id="popover-trans-type"
                value={transactionTypeFilter || 'ALL'}
                onChange={e => {
                  if (setTransactionTypeFilter) setTransactionTypeFilter(e.target.value);
                  setPage(1);
                }}
                label="Loại giao dịch"
              >
                <MenuItem value="ALL">Tất cả</MenuItem>
                <MenuItem value="ORDERS">Đơn bán hàng</MenuItem>
                <MenuItem value="RECEIPTS">Phiếu thu</MenuItem>
              </Select>
            </FormControl>
          )}

          <FormControl variant="outlined" size="small" fullWidth>
            <InputLabel
              id="device-label"
              style={{
                backgroundColor: 'white',
                padding: '0 4px',
                marginLeft: -4
              }}
            >
              Loại Thiết bị
            </InputLabel>
            <Select
              labelId="device-label"
              id="filter-device"
              value={filterDevice}
              onChange={e => {
                setFilterDevice(e.target.value);
                setPage(1);
              }}
              label="Loại Thiết bị"
            >
              <MenuItem value="all">Tất cả</MenuItem>
              {(listDeviceType || []).map(d => (
                <MenuItem key={d.id} value={d.id}>
                  {d.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {(isAdmin || isAccountant || isLeadMarketing) && (
            <FormControl variant="outlined" size="small" fullWidth>
              <InputLabel
                id="sale-label"
                style={{
                  backgroundColor: 'white',
                  padding: '0 4px',
                  marginLeft: -4
                }}
              >
                Nhân viên Sale
              </InputLabel>
              <Select
                labelId="sale-label"
                id="filter-sale"
                value={filterSale}
                onChange={e => {
                  setFilterSale(e.target.value);
                  setPage(1);
                }}
                label="Nhân viên Sale"
              >
                <MenuItem value="all">Tất cả</MenuItem>
                {availableSales.map(u => (
                  <MenuItem key={u.id} value={u.id}>
                    {u.full_name || u.fullName || u.username}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}

          <Button
            fullWidth
            variant="contained"
            color="primary"
            onClick={handleFilterClose}
            style={{ textTransform: 'none', fontWeight: 600, borderRadius: 8 }}
          >
            Áp dụng
          </Button>
        </Popover>

        {(fromDate ||
          toDate ||
          (!isAnySale && transactionTypeFilter && transactionTypeFilter !== 'ALL') ||
          filterDevice !== 'all' ||
          filterSale !== 'all' ||
          filterStatus !== 'all' ||
          search) && (
          <Tooltip title="Đặt lại tất cả bộ lọc về mặc định">
            <Button
              size="small"
              onClick={() => {
                setFromDate('');
                setToDate('');
                if (setTransactionTypeFilter) setTransactionTypeFilter(isAnySale ? 'ORDERS' : 'ALL');
                if (setFilterPaymentStatus) setFilterPaymentStatus('all');
                setFilterDevice('all');
                setFilterSale('all');
                if (setFilterItemType) setFilterItemType('all');
                setFilterStatus('all');
                setSearch('');
                setSearchInput('');
                setPage(1);
              }}
              startIcon={<CloseIcon style={{ fontSize: 15 }} />}
              style={{
                height: 40,
                boxSizing: 'border-box',
                borderRadius: 8,
                color: '#e11d48',
                backgroundColor: '#fff1f2',
                border: '1px solid #fecdd3',
                textTransform: 'none',
                fontWeight: 600,
                fontSize: 12.5,
                whiteSpace: 'nowrap',
                padding: '0 12px',
                marginTop: -3
              }}
            >
              Xóa lọc
            </Button>
          </Tooltip>
        )}

        <Box display="flex" alignItems="center" style={{ marginLeft: 'auto', gap: 12 }}>
          {handleExportExcel && (
            <Button
              variant="contained"
              onClick={handleExportExcel}
              startIcon={<GetAppIcon />}
              style={{
                fontWeight: 600,
                height: 40,
                borderRadius: 8,
                backgroundColor: '#10b981',
                color: '#fff',
                textTransform: 'none',
                whiteSpace: 'nowrap',
                boxShadow: '0 2px 8px rgba(16,185,129,0.25)'
              }}
            >
              Xuất Excel
            </Button>
          )}

          {canManageReceipts && onOpenAddReceiptGeneral && (
            <Button
              variant="contained"
              color="primary"
              onClick={onOpenAddReceiptGeneral}
              style={{
                fontWeight: 600,
                height: 40,
                borderRadius: 8,
                textTransform: 'none',
                whiteSpace: 'nowrap'
              }}
            >
              + phiếu thu
            </Button>
          )}

          {(isAdmin || isSale || isLeadMarketing) && setOpenAddModal && (
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                if (setIsEditing) setIsEditing(false);
                if (setEditOrderId) setEditOrderId(null);
                if (setForm) {
                  setForm({
                    account: '',
                    paymentMethod: 'Tiền mặt',
                    type: '',
                    simType: '',
                    isNewOrder: '',
                    note: '',
                    fullName: '',
                    phone: '',
                    company: '',
                    installationType: '',
                    extra_fee: 0,
                    vat: 0,
                    order_type: 'SALE'
                  });
                }
                if (setDevices) setDevices([{ type: 'VGPS_CAM4G', quantity: 1, unitPrice: 0, simType: 'Sim đại lý', simNetwork: '' }]);
                if (setOrderParts) setOrderParts([{ product_id: '', product_code: '', product_name: '', quantity: 1, unit_price: 0, discount: 0, agency_id: '', description: '' }]);
                if (setSelectedUser) setSelectedUser(null);
                const isGlobalSale = isAdmin || isAdminSale;
                if (setTabForm) {
                  setTabForm(isGlobalSale ? 0 : 1);
                }
                setOpenAddModal(true);
              }}
              style={{
                fontWeight: 600,
                height: 40,
                borderRadius: 8,
                textTransform: 'none',
                whiteSpace: 'nowrap'
              }}
            >
              {'+ phiếu bán hàng'}
            </Button>
          )}
        </Box>
      </Card>
    </>
  );
};

export default ToolbarSection;
